import { loadAttachmentInformation, getGroupMailboxInfo } from 'owa-group-files-hub-adaptors';
import { AttachmentFileInformation } from 'owa-group-files-hub-store';
import { isPdfExtension } from '../utils/fileExtensionManager';
import { ClientAttachmentId, MailboxInfo } from 'owa-client-ids';
import {
    getUserAttachmentPolicyChecker,
    initializeWacAttachmentInfo,
} from 'owa-group-files-hub-adaptors';

// Record wac attachment which we already initialized its URL. It is valid for entire OWA session.
const InitializedWacAttachmentId = [];

export default function prefetchAttachmentPreviewInformation(
    fileList: AttachmentFileInformation[]
) {
    // Prefetch information for all attachments as well as WAC URL for WAC files
    const attachmentIdList: ClientAttachmentId[] = [];
    for (const file of fileList) {
        const groupMailboxInfo: MailboxInfo = getGroupMailboxInfo(file.groupSmtpAddress);
        const attachmentId: ClientAttachmentId = {
            Id: file.attachmentId,
            mailboxInfo: groupMailboxInfo,
        };

        attachmentIdList.push(attachmentId);
        const attachmentPolicyInfo = getUserAttachmentPolicyChecker().getPolicyInfo(
            file.extension,
            null,
            true,
            'FileAttachment:#Exchange'
        );

        if (
            attachmentPolicyInfo.useWac &&
            !isPdfExtension(file.extension) &&
            InitializedWacAttachmentId.indexOf(attachmentId.Id) == -1
        ) {
            initializeWacAttachmentInfo(attachmentId);
            InitializedWacAttachmentId.push(attachmentId.Id);
        }
    }

    if (attachmentIdList.length > 0) {
        loadAttachmentInformation(attachmentIdList);
    }
}
